import { BillingSubscriberProductModel } from "./BillingSubscriberProductModel"
import { BillingInvoiceModel } from "./BillingInvoiceModel"
import { BillingBilletModel } from "./BillingBilletModel"
import { BillingTypeModel } from "./BillingTypeModel"
import { addDays, isAfter } from "date-fns"
import { BilletModel } from "./BilletModel"
import { InvoiceModel } from "./InvoiceModel"

export class BillingModel {
    id: string = ""
    createdAt: Date|string|null = null
    canceledAt: Date|string|null = null
    canceledBy: string = ''
    dueDate: Date|string|null = null
    grossTotal: number = 0
    discountValue: number = 0
    increaseValue: number = 0
    total: number = 0
    referenceDate: Date|string|null = null
    description: string = ""
    paymentDate: Date|string|null = null
    subscriberProduct: BillingSubscriberProductModel
    type: BillingTypeModel
    invoices: BillingInvoiceModel[] = []
    billets: BillingBilletModel[] = []
    loadingListAction?: boolean = false

    constructor(b?:Partial<BillingModel>) {
        Object.assign(this, b)

        this._parseSubscriberProduct()
        this._parseBillingType()
        this._parseInvoices()
        this._parseBillets()
    }

    getStatusDescription():string {
        if (this.hasBeenCanceled()) {
            return 'Cancelado'
        }

        if (this.hasBilletBeenPaid()) {
            return 'Pago'
        }

        if (this.isOverdue()) {
            return 'Vencido'
        }

        return 'Em aberto'                                    
    }

    getBillet():BilletModel {
        return this.billets?.[0]?.billet || new BilletModel()
    }

    getInvoice():InvoiceModel {
        return this.invoices?.[0]?.invoice || new InvoiceModel()
    }

    hasBillets():boolean {
        return !!this.billets.length
    }

    hasInvoices():boolean {
        return !!this.invoices.length
    }

    hasBilletBeenPaid():boolean {
        return !!this.paymentDate
    }
    
    hasBeenCanceled():boolean {
        return !!this.canceledAt
    }

    isOverdue():boolean {
        if (!this.dueDate) {
            return false
        }

        if (this.hasBilletBeenPaid()) {
            return false
        }

        if (this.hasBeenCanceled()) {
            return false
        }

        const today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
        let dueDate = addDays(new Date(this.dueDate), 1) 
        dueDate = new Date(new Date(dueDate).getFullYear(), new Date(dueDate).getMonth(), new Date(dueDate).getDate())

        return isAfter(today, dueDate)
    }

    getEmail():string {
        return this.subscriberProduct?.subscriber?.addresses?.[0]?.email || ''
    }

    getEmailList():string[] {
        const email = this.getEmail()

        if (!email) {
            return []
        }

        return email.split(',')
    }

    getInvoiceUrl():string {
        return this.invoices?.[0]?.invoice?.url || ''
    }

    getBilletUrlPdf():string {
        return this.billets?.[0]?.billet?.urlPdf || ''
    }

    getBilletUrlView():string {
        return this.billets?.[0]?.billet?.urlView || ''
    }

    private _parseBillingType():void {
        this.type = new BillingTypeModel(this.type)
    }

    private _parseSubscriberProduct():void {
        this.subscriberProduct = new BillingSubscriberProductModel(this.subscriberProduct)
    }

    private _parseInvoices():void {
        this.invoices = (this.invoices || []).map((inv) => new BillingInvoiceModel(inv))
    }

    private _parseBillets():void {
        this.billets = (this.billets || []).map((billet) => new BillingBilletModel(billet))
    }
}

